import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";

const Footer = () => {
  return (
    <footer className="bg-dark text-white pt-0 pb-1">
      <div className="container text-center text-md-left">
        <div
          className="row text-center text-md-left"
          style={{ backgroundColor: "#f7f7f7" }}
        >
          <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
            <div className="mt-4">
              <h5 className="text-uppercase mb-3 font-weight-bold text-info">
                Quick Links
              </h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="/Csr" className="text-dark text-decoration-none">
                    Social Responsibility (CSR)
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="https://blog.shrigwalexim.com/"
                    className="text-dark text-decoration-none"
                  >
                    Newsroom
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/Investor"
                    className="text-dark text-decoration-none"
                  >
                    Investor
                  </a>
                </li>
                <li className="mb-2">
                  <a href="/Careers" className="text-dark text-decoration-none">
                    Careers
                  </a>
                </li>
                <li className="mb-2">
                  <a href="/Faq" className="text-dark text-decoration-none">
                    FAQs
                  </a>
                </li>
              </ul>
              <h5 className="text-uppercase mb-3 font-weight-bold text-info">
                Legal Disclosures
              </h5>
              <ul className="list-unstyled">
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <a
                      href="/PrivacyNotice"
                      className="text-dark text-decoration-none"
                    >
                      Privacy Notice
                    </a>
                  </li>
                  <li className="mb-2">
                    <a
                      href="/CookiePolicy"
                      className="text-dark text-decoration-none"
                    >
                      Cookie Policy
                    </a>
                  </li>
                  <li className="mb-2">
                    <a
                      href="/Accessibility"
                      className="text-dark text-decoration-none"
                    >
                      Accessibility
                    </a>
                  </li>
                  <li className="mb-2">
                    <a
                      href="/Disclaimer"
                      className="text-dark text-decoration-none"
                    >
                      Disclaimer
                    </a>
                  </li>
                  <li className="mb-2">
                    <a
                      href="/SecurityPolicy"
                      className="text-dark text-decoration-none"
                    >
                      Security Policy
                    </a>
                  </li>
                  <li className="mb-2">
                    <a
                      href="/CaliforniaNotice"
                      className="text-dark text-decoration-none"
                    >
                      California Notice
                    </a>
                  </li>
                </ul>
              </ul>
            </div>
          </div>
          {/* <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
            <h5 className="text-uppercase mb-4 font-weight-bold text-info">
              Get in Touch
            </h5>
            <h6>
              <a
                href="mailto:info@shigwalexim.com"
                className="text-dark text-decoration-none"
              >
                info@shigwalexim.com
              </a>
            </h6>
            <h6>
              <a
                href="mailto:info@shigwalexim.com"
                className="text-dark text-decoration-none"
              >
                admin@shigwalexim.com
              </a>
            </h6>
            <h6 className="text-dark">
              <i className="bi bi-houses" style={{ marginRight: "5px" }}></i>{" "}
              New Delhi, India
            </h6>
            <h6 className="text-dark">
              <i className="bi bi-telephone" style={{ marginRight: "5px" }}></i>{" "}
              +91 9350132742
            </h6>
            <h6 className="text-dark">
              <i className="bi bi-telephone" style={{ marginRight: "5px" }}></i>{" "}
              +91 9582646647
            </h6>
            <h6 className="text-dark">
              <i className="bi bi-headset" style={{ marginRight: "5px" }}></i>{" "}
              +91 8576891104
            </h6>
          </div> */}
          <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
            <h5 className="text-uppercase mb-4 font-weight-bold text-info">
              Registered Office
            </h5>
            <p className="text-dark">
              <i className="bi bi-buildings" style={{ marginRight: "5px" }}></i>
              <a
                href="https://maps.app.goo.gl/tEHMRN7s3nJq374r6"
                className="text-dark text-decoration-none"
              >
                {" "}
                Plot No 10, Sainik Vihar, PH 3, Mohan Garden, Uttam Nagar,
                Delhi, 110059, India
              </a>
            </p>
            <span>
              <embed
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.5533522807077!2d77.0302433752895!3d28.643145675658925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d051cc7407c47%3A0x6e8c34d35d0906eb!2sShri%20Gwal%20Exim%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1704677359302!5m2!1sen!2sin"
                width="250"
                height="230"
                allowFullScreen=""
                overflow-hidden
                referrerPolicy="no-referrer-when-downgrade"
              ></embed>
            </span>
          </div>
        </div>
        <hr className="mb-4"></hr>
        <div className="row align-items-center">
          <div className="col-md-7 col-lg-8">
            <ul className="list-unstyled list-inline">
              <li className="list-inline-item">
                <a
                  href="https://www.facebook.com/shrigwalexim/"
                  className="btn-floating btn-sm text-white"
                  style={{ marginLeft: "23px" }}
                >
                  <i
                    className="bi bi-facebook"
                    style={{ fontSize: "30px" }}
                  ></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  href="https://www.instagram.com/shrigwalexim/"
                  className="btn-floating btn-sm text-white"
                  style={{ marginLeft: "23px" }}
                >
                  <i
                    className="bi bi-instagram"
                    style={{ fontSize: "30px" }}
                  ></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  href="https://www.youtube.com/@shrigwalexim/"
                  className="btn-floating btn-sm text-white"
                  style={{ marginLeft: "23px" }}
                >
                  <i className="bi bi-youtube" style={{ fontSize: "30px" }}></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  href="https://www.linkedin.com/company/shrigwalexim/"
                  className="btn-floating btn-sm text-white"
                  style={{ marginLeft: "23px" }}
                >
                  <i
                    className="bi bi-linkedin"
                    style={{ fontSize: "30px" }}
                  ></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  href="https://twitter.com/shrigwalexim/"
                  className="btn-floating btn-sm text-white"
                  style={{ marginLeft: "23px" }}
                >
                  <i
                    className="bi bi-twitter-x"
                    style={{ fontSize: "30px" }}
                  ></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  href="https://www.pinterest.com/shrigwalexim/"
                  className="btn-floating btn-sm text-white"
                  style={{ marginLeft: "23px" }}
                >
                  <i
                    className="bi bi-pinterest"
                    style={{ fontSize: "30px" }}
                  ></i>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-5 col-lg-4">
            <div className="text-center text-md-right">
              <p>
                Copyright © 2025. All rights reserved.{" "}
                <small className="text-warning">Shri Gwal Exim Pvt. Ltd.</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
